import { makeStyles } from "@material-ui/styles";

export default makeStyles(theme => ({
    heading: {
        fontWeight: "bold",
        color: theme.palette.text.disabled
    },
    value: {
        overflowX: "auto",
        background: theme.palette.background.default
    }
}))